/**
 * The "Upcoming" figures above billing history.
 *
 * 2026-10-10: "Upcoming +$" counted scheduled payments that had FAILED (or
 * were otherwise not going to run) as money on its way, and "Upcoming -$"
 * counted drafts, which the family has not been sent, as charges on their
 * way. Only what will actually happen is counted now; failed payments and
 * drafts are reported separately.
 */
export interface UpcomingSummary {
  /** Published future charges (not drafts, not canceled). */
  chargesTotal: number;
  /** Future charges still in draft. */
  draftsTotal: number;
  draftsCount: number;
  /** Scheduled payments that will still run (pending or in progress). */
  scheduledTotal: number;
  /** Scheduled payments that failed and will not run again by themselves. */
  failedTotal: number;
  failedCount: number;
}

const WILL_RUN = new Set(["pending", "processing"]);
const money = (n: unknown) => Math.round((Number(n) || 0) * 100) / 100;

export function summarizeUpcoming(futureInvoices: any[] = [], scheduledPayments: any[] = []): UpcomingSummary {
  const s: UpcomingSummary = {
    chargesTotal: 0,
    draftsTotal: 0,
    draftsCount: 0,
    scheduledTotal: 0,
    failedTotal: 0,
    failedCount: 0,
  };
  for (const inv of futureInvoices || []) {
    if (!inv || inv.status === "cancelled") continue;
    if (inv.type === "credit" || inv.metadata?.type === "credit") continue;
    if (inv.post_status === "draft") {
      s.draftsTotal = money(s.draftsTotal + money(inv.amount));
      s.draftsCount += 1;
    } else {
      s.chargesTotal = money(s.chargesTotal + money(inv.amount));
    }
  }
  for (const p of scheduledPayments || []) {
    if (!p) continue;
    if (WILL_RUN.has(p.status)) {
      s.scheduledTotal = money(s.scheduledTotal + money(p.amount));
    } else if (p.status === "failed") {
      s.failedTotal = money(s.failedTotal + money(p.amount));
      s.failedCount += 1;
    }
  }
  return s;
}
